import rowConfig from './rowConfig';
import { RowConfigsProps } from '../../types';

const getConfig = ({ columnsProps }: RowConfigsProps) => ({
  className: 'h-model-terminal-table',
  rowConfig: rowConfig(columnsProps),
});

export default getConfig;
